// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__ztkw1","title":"AfterBackImages_title__2E5S-","images":"AfterBackImages_images__1h4K9"};